import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Builder } from 'builder-pattern';
import { OneToNEnroll } from './classes/one-to-n-enroll';
import { LibConfig, LibConfigService } from './enroll.module';

@Injectable({
  providedIn: 'root',
})
export class EnrollService {
  constructor(
    @Inject(LibConfigService) private config: LibConfig,
    private http: HttpClient
  ) {}

  public oneToNEnroll(
    request: any,
    accessToken: string
  ): Observable<OneToNEnroll> {
    return this.http
      .post(
        `${
          this.config.apiUrl
            ? this.config.apiUrl
            : 'https://dev-facade-1ton-http-635t26xtnq-uc.a.run.app/api/v1/one2n/enroll/'
        }`,
        request,
        {
          headers: new HttpHeaders()
            .set('authorization', `Bearer ${accessToken}`)
            .append('auth', `Bearer ${accessToken}`),
        }
      )
      .pipe(
        map((response: any) =>
          Builder(OneToNEnroll)
            .id(response.eventId)
            .status(response.status)
            .enrolled(
              response.enrolled ? response.enrolled : response.enrolling
            )
            .message(response.message ?? '')
            .error(response.error ?? '')
            .processTime(response.procesTime)
            .user(response.user)
            .build()
        )
      );
  }
}
